import styled, { css } from 'styled-components';

import { device } from 'styles/breakpoints';

export const HeaderWrapper = styled.header<{
  whiteHeader: boolean;
  transparentHeader?: boolean;
}>`
  position: fixed;
  z-index: 910;
  top: 0;
  left: 0;
  width: 100%;
  height: 108px;
  display: flex;
  justify-content: center;
  transition: 300ms all ease;
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: 200ms all ease;
    &:first-child {
      padding: 0 80px;
    }
  }
  ${({ whiteHeader, theme }) =>
    whiteHeader &&
    css`
      background-color: rgba(255, 255, 255, 0.9);
      backdrop-filter: blur(12px);

      .header-phone > p,
      .header-nav p,
      .account-logout > p {
        color: ${theme.colors.bluePallet1} !important;
      }
    `}
  @media ${device.laptop} {
    > div {
      &:first-child {
        padding: 0 20px;
      }
    }
  }
  @media ${device.tablet} {
    height: 65px;
  }

  ${({ transparentHeader, theme }) =>
    transparentHeader &&
    css`
      .header-phone > p,
      .header-nav p,
      .account-logout > p {
        color: ${theme.colors.bluePallet1} !important;
      }
    `}
`;

export const HeaderLogo = styled.a`
  display: flex;
  flex-shrink: 0;
`;

export const HeaderNav = styled.nav`
  display: flex;
  flex-grow: 1;
  margin-left: 80px;
  margin-right: 20px;
  gap: 48px;
  > a {
    margin: 0 12px;
    > p {
      color: ${({ theme }) => theme.colors.white};
    }
  }
  @media ${device.laptop} {
    display: none;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  .header {
    &-valuation {
      flex-shrink: 0;
      width: 252px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 16px;
      border-radius: 60px;
      background-color: ${({ theme }) => theme.colors.bluePallet1};
      > p {
        color: ${({ theme }) => theme.colors.white};
      }
      &-mobile {
        display: flex;
        padding: 10px;
      }
    }
    &-login {
      flex-shrink: 0;
      display: flex;
      padding: 12px 16px;
      width: 78px;
      height: 48px;
      border-radius: 60px;
      background-color: ${({ theme }) => theme.colors.green};
      > p {
        color: ${({ theme }) => theme.colors.bluePallet1};
      }
    }
    &-phone {
      flex-shrink: 0;
      display: flex;
      margin-right: 65px;
      > p {
        color: ${({ theme }) => theme.colors.white};
        text-decoration: underline;
      }
    }
    &-burger {
      display: flex;
      width: 32px;
      height: 32px;
      cursor: pointer;
      background-color: transparent;
    }
  }
`;

export const HeaderNavigationMobileWrapper = styled.div`
  .mobile-menu {
    height: 100vh;
    position: absolute;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.bluePallet3};
    display: flex;
    flex-direction: column;
    &-close {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 108px;
      padding: 0 20px;
      transition: 200ms all ease;
      > button {
        width: 32px;
        height: 32px;
        display: flex;
        cursor: pointer;
        background-color: transparent;
      }
    }
    &-logo {
      margin-top: 40px;
      margin-bottom: 40px;
      display: flex;
      justify-content: center;
    }
    &-content {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    &-list {
      display: flex;
      flex-direction: column;
      gap: 28px;
      > li {
        display: flex;
        justify-content: center;
        > a {
          display: flex;
          position: relative;
          &:after {
            display: none;
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            width: 66px;
            height: 11px;
            background-image: url('/static/icons/vectors/vector-1.svg');
            background-repeat: no-repeat;
          }
          &.active::after {
            display: block;
          }
          > p {
            color: ${({ theme }) => theme.colors.white};
          }
        }
      }
    }
    &-phone {
      > p {
        color: ${({ theme }) => theme.colors.white};
        text-decoration: underline;
        text-align: center;
      }
    }
    &-actions {
      padding-bottom: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
      &-login {
        flex-shrink: 0;
        display: flex;
        padding: 12px 16px;
        width: 78px;
        height: 48px;
        border-radius: 60px;
        background-color: ${({ theme }) => theme.colors.green};
        > p {
          color: ${({ theme }) => theme.colors.bluePallet1};
        }
      }
      &-valuation {
        display: flex;
        background: ${({ theme }) => theme.colors.bluePallet5};
        padding: 12px 16px;
        border-radius: 60px;
        width: 252px;
        height: 48px;
      }
      &-logout {
        display: flex;
        background-color: transparent;
        cursor: pointer;
        padding: 0 16px;
        > p {
          color: ${({ theme }) => theme.colors.white};
        }
      }
    }
  }
  @media ${device.tablet} {
    .mobile-menu {
      &-close {
        height: 65px;
      }
      &-actions {
        flex-direction: column;
      }
    }
  }
  /* > div {
    > div {
      padding: 0 24px;
      display: flex;
      > a {
        display: flex;
        border-bottom: 3px solid ${({ theme }) => theme.colors.green};
        > p {
          color: ${({ theme }) => theme.colors.white};
        }
      }
    }
  }
  */
`;

export const HeaderAccountWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  .account {
    &-avatar {
      width: 42px;
      height: 42px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${({ theme }) => theme.colors.white};
      margin-right: 12px;
      border-radius: 50%;
      > p {
        color: ${({ theme }) => theme.colors.green};
      }
    }
    &-logout {
      display: flex;
      > p {
        color: ${({ theme }) => theme.colors.white};
      }
    }
    &-info {
      display: flex;
      > p {
        color: ${({ theme }) => theme.colors.white};
        margin-right: 4px;
      }
    }
    &-dropdown {
      position: absolute;
      z-index: 3;
      width: 190px;
      top: calc(100% + 12px);
      right: 0;
      background-color: ${({ theme }) => theme.colors.white};
      border: 1px solid ${({ theme }) => theme.colors.green};
      border-radius: 8px;
      padding: 6px 16px;
      &-item {
        padding: 12px 0;
        display: flex;
        align-items: center;
        > p {
          margin-left: 8px;
        }
      }
    }
  }
  @media ${device.laptop} {
    .account {
      &-avatar {
        margin-right: 0;
      }
      &-logout {
        display: none;
      }
      &-dropdown {
        left: auto;
        right: -8px;
      }
    }
  }
  @media ${device.tablet} {
    margin-left: 22px;
    .account {
      &-avatar {
        width: 30px;
        height: 30px;
        > p {
          font-size: 14px;
        }
      }
    }
  }
  @media ${device.mobile} {
    .account {
      &-avatar {
        margin-right: 6px;
      }
      &-info {
        > p {
          display: none;
        }
      }
    }
  }
`;

export const HeaderBottomBlockWrapper = styled.div`
  position: fixed;
  z-index: 910;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  background-color: ${({ theme }) => theme.colors.bluePallet3};
  transition: 300ms all ease;

  > a {
    display: flex;
    gap: 12px;
    > p {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;
